import { render, staticRenderFns } from "./Staging.vue?vue&type=template&id=b32a1872&scoped=true&"
import script from "./Staging.vue?vue&type=script&lang=js&"
export * from "./Staging.vue?vue&type=script&lang=js&"
import style0 from "./Staging.vue?vue&type=style&index=0&id=b32a1872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a1872",
  null
  
)

export default component.exports